import React, { useState } from 'react';
import {socialAccounts ,socialBtns, contact} from '../../utils/config'
import './SocialIcons.css'
import callIcon from './phone-icon.svg'
import wspIcon from './whatsapp-icon.svg'
import igIcon from './instagram-icon.svg'
import fbIcon from './facebook-icon.svg'
import mail from './mail-icon.svg'
import review from './review.svg'
import waze from './waze-icon.svg'
import menu from './menu-icon.svg'
import Modal from 'react-modal';
import FeedbackForm from '../Feedback/Feedback';


const icons = [
    { "action": "Menu", "svg": menu, "text":socialBtns.menu },
    { "action": "Call", "svg": callIcon, "text":socialBtns.callIcon },
    { "action": "Wsp", "svg": wspIcon, "text":socialBtns.wspIcon },
    { "action": "IG", "svg": igIcon, "text":socialBtns.igIcon },
    { "action": "FB", "svg": fbIcon, "text":socialBtns.fbIcon },
    { "action": "Mail", "svg": mail, "text":socialBtns.mail },
    { "action": "reviewus", "svg": review, "text":socialBtns.review },
    { "action": "waze", "svg": waze, "text":socialBtns.waze },
]

const SocialIcons = () => {
    const [isReviewModalOpen, setIsReviewModalOpen] = useState(false);


    const openReviewModal = () => {
        setIsReviewModalOpen(true);
    };
    const closeReviewModal = () => {
        setIsReviewModalOpen(false);
    };

    const handleClick = (action) => {
        switch (action) {
            case "Call":
                window.location.href = `tel:${contact.phone}`
                break;
            case "Wsp":
                window.open(socialAccounts.wsp)
                break;
            case "IG":
                window.open(socialAccounts.ig)
                break;
            case "FB":
                window.open(socialAccounts.fb)
                break;
            case "Mail":
                window.location.href = `mailto:${contact.email}`
                break;
            case "Menu":
                window.open(contact.menu)
                break;
            case "reviewus":
                openReviewModal();
                break;
            case "waze":
                window.open(contact.waze)
                break;
            default:
                console.log("Invalid action");
        }
    };
    
    return (
        <div className="SocialIcons">
            {icons.map((icon) => (
                <div key={icon.action} onClick={() => handleClick(icon.action)} className="socialIcon">
                    <img src={icon.svg} alt={icon.action} />
                    <span>{icon.text}</span>
                </div>
            ))}

            <Modal isOpen={isReviewModalOpen} onRequestClose={closeReviewModal} className="modal feedback" overlayClassName="overlay">
                <div className="modal-content">
                    <h2>דרגו אותנו לפי השירות שקבלתם</h2>
                    <FeedbackForm/>
                </div>
            </Modal>
        </div>

    )
}

export default SocialIcons